import { rupee } from "@/lib/constants";

// Per-job payout breakdown: what the job earned, what HOMIIE kept, and what is still due to the Pro.
export function PayoutBreakdown({ p }) {
    const rows = [
        ["Labour", p.labour_amount],
        ["Visit fee", p.visit_amount],
        ["Materials (old rule)", p.materials_v2 ? 0 : p.material_amount],
        ["Less: HOMIIE visit margin", -(p.visit_margin || 0)],
        ["Less: commission on labour", -(p.labour_commission || 0)],
        ["Less: material cash already received", p.materials_v2 ? 0 : -(p.material_cash_collected || 0)],
    ].filter(([, v]) => Number(v || 0) !== 0);
    return (
        <div className="mt-2 space-y-0.5 rounded-xl bg-navy/[0.03] p-2.5 text-xs" data-testid={`payout-breakdown-${p.booking_ref}`}>
            {rows.map(([l, v]) => (
                <div key={l} className="flex justify-between"><span className="text-navy/55">{l}</span><span className={v < 0 ? "font-semibold text-rose-600" : "font-semibold text-navy"}>{v < 0 ? `−${rupee(-v)}` : rupee(v)}</span></div>
            ))}
            <div className="mt-1 flex justify-between border-t border-navy/10 pt-1 text-sm"><span className="font-bold text-navy">{p.status === "Paid" ? "Paid to you" : "Remaining due to you"}</span><span className="font-heading font-extrabold text-navy" data-testid={`payout-net-${p.booking_ref}`}>{rupee(p.final_payout)}</span></div>
            <p className="text-[10px] text-navy/40">Customer bill {rupee(p.customer_price)}{p.paid_at ? ` · paid ${String(p.paid_at).slice(0, 10)}` : ""}{p.utr ? ` · UTR ${p.utr}` : ""}</p>
        </div>
    );
}
